module.exports = __webpack_public_path__ + "static/img/duijieyiliu.8724520.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/duijieyiliu.png
// module id = mTXL
// module chunks = 1